import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import PostOperativeHoursIcon from '@cp/src/assets/images/icons/PostOperativeHoursIcon';
import Overlay from '@cp/src/components/Overlay/Overlay';
import { useEffect } from 'react';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

const PostOperativeHours = () => {
  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_POST_OPERATIVE_HOURS_SCREEN_LOADED);
  }, []);

  return (
    <Overlay visible={true}>
      <div className={styles.card}>
        <div className={styles.hoursIcon}>
          <PostOperativeHoursIcon />
        </div>
        <Typography variant="p5" className={styles.headerTxt}>
          You have logged in post operative hours!
        </Typography>
        <Typography as="span" variant="p5" className={styles.description}>
          Please{' '}
          <Typography as="span" variant="p5" className={`${styles.description} font-medium`}>
            login between operative hours (8AM - 7PM)
          </Typography>{' '}
          <br />
          to access Longhorn
        </Typography>
      </div>
    </Overlay>
  );
};

export default PostOperativeHours;
